import * as React from 'react';
import { Message } from 'semantic-ui-react';
export var ErrorAlert = function (_a) {
    var children = _a.children;
    return (<Message negative>
		<Message.Header>{children}</Message.Header>
	</Message>);
};
